// src/VerifyPin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, firestore } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import "./VerifyPin.css";
import Lock from '../src/assets/SignUpIcon/unlock.svg'
import Binn from '../src/assets/SignUpIcon/bin.svg'
import Keyy from '../src/assets/SignUpIcon/key.svg'
import Verii from '../src/assets/SignUpIcon/veri.png'

const VerifyPin = () => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handlePinSubmit = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (user) {
      try {
        const userDoc = await getDoc(doc(firestore, "users", user.uid));
        if (userDoc.exists() && userDoc.data().pin === pin) {
          navigate("/dashboard");
        } else {
          setError("Incorrect PIN");
        }
      } catch (error) {
        console.error("Error verifying PIN:", error);
        setError("An error occurred. Please try again.");
      }
    } else {
      navigate("/");
    }
  };

  const handleKeyClick = (value) => {
    if (pin.length < 4) {
      setPin(pin + value);
    }
  };

  const handleDelete = () => {
    setPin(pin.slice(0, -1));
  };

  return (
    <div className="verify-pin-container">
      <div className="VerifyTop">
        <div className="lockBox">
        <img style={{width: 36}} src={Keyy} alt="" />
        </div>
      <h2 style={{marginBottom: 2,}} >Confirm Your PIN  </h2>
      <p style={{padding: 2, fontSize: 15}} >
       secured by UBS banking service <img style={{width: 15}} src={Lock} alt="" />
       <img style={{width: 14, marginLeft: 4,}} src={Verii} alt="" />
      </p>
      </div>
      <form className="formit" onSubmit={handlePinSubmit}>
        <div className="inputter" >
        
        <input className="inputte" type="password" value={pin} readOnly />
        </div>
        {error && <p className="error">{error}</p>}
        <div className="custom-keyboard">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
            <button
              type="button"
              key={num}
              onClick={() => handleKeyClick(num.toString())}
            >
              {num}
            </button>
          ))}
          <button type="button" onClick={handleDelete}>
          <img style={{width: 26}} src={Binn} alt="" />
          </button>
          <button type="button" onClick={() => handleKeyClick("0")}>
            0
          </button>
          <button style={{backgroundColor: '#000000', color: '#f5f6f7', fontSize: 17, textAlign: 'center', alignItems: 'center', justifyContent: 'center'  }} type="submit">Enter</button>
        </div>
      </form>
    </div>
  );
};

export default VerifyPin;
